/**
 * 时间戳转年月日
 * @param timestamp
 * @returns {string}
 */
export function getYMDHMS(timestamp) {
  let time = new Date(timestamp);
  let year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, '0');
  const date = time.getDate().toString().padStart(2, '0');
  const hours = time.getHours().toString().padStart(2, '0');
  const minute = time.getMinutes().toString().padStart(2, '0');
  const second = time.getSeconds().toString().padStart(2, '0');
  return (
    year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
  );
}

/**
 * 解析URL参数
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var result = window.location.search.substr(1).match(reg);
  return result ? decodeURIComponent(result[2]) : null;
}

/**
 * 设置标题描述
 * @param title
 * @param keywords
 * @param description
 */
export function updateTitle(title, keywords, description) {
  console.log(title + '---' + keywords + '---' + description);
  document.title = title;
  document.getElementById('keywords').content = keywords;
  document.getElementById('description').content = description;
}
/**
 * 中间省略
 * @param {*} str 
 * @param {*} num 
 * @returns 
 */
export function truncateString(str) {
  if (str.length <= 25) {
    return str;
  } else {
    return str.slice(0, 19) + "..." + str.slice(str.length - 3);
  }
}